export default{
    async registerTherapist(context, data){
        const userId = context.rootGetters.userId;
        const therapistData = {
            firstName: data.first,
            lastName: data.last,
            description: data.desc,
            hourlyRate: data.rate,
            areas: data.areas
        };

        const token = context.rootGetters.token;

        const response = await fetch(`https://betterhelp-74ef7-default-rtdb.firebaseio.com/therapists/${userId}.json?auth=`+ 
            token, 
        {
            // process.env.FIREBASE_THERAPIST
            method: 'PUT',
            body: JSON.stringify(therapistData),
        });

        // const responseData = await response.json();

        if(!response.ok){
            const error = new Error(response.message || 'Failed to fetch data');
            throw error;
        }

        context.commit('registerTherapist', {
            ...therapistData,
            id: userId,
        });
    },
    async loadTherapists(context, payload){
        if(!payload.forceRefresh && !context.getters.shouldUpdate){
            return;
        }

        const response = await fetch(`https://betterhelp-74ef7-default-rtdb.firebaseio.com/therapists.json`);
        
        const responseData = await response.json();

        if(!response.ok){
            const error = new Error(responseData.message || 'Failed to fetch data');
            throw error;
        }
        const therapists = [];
        
        // Loop through Firebase Obj
        for(const key in responseData){
            const therapist = {
                id: key,
                firstName: responseData[key].firstName,
                lastName: responseData[key].lastName,
                description: responseData[key].description,
                hourlyRate: responseData[key].hourlyRate,
                areas: responseData[key].areas,
            };
            therapists.push(therapist);
        }
        context.commit('setTherapists', therapists);
        context.commit('setFetchTimestamp');
    },
};